import { SelectChangeEvent } from "@mui/material";

import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface SelectBoxProps<T> {
  availableOptions: T[];
  selectedOption: T | null;
  onOptionChange: (option: T) => void;
  id: string;
  labelId: string;
  label: string;
}

export const SelectBox = <T,>({
  availableOptions,
  selectedOption,
  onOptionChange,
  id,
  labelId,
  label,
}: SelectBoxProps<T>) => {
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent) => {
    onOptionChange(event.target.value as T);
  };

  return (
    <FormControl
      size="small"
      sx={{
        gap: 0.5,
        minWidth: 240,
        alignSelf: "flex-end",
        "& .MuiInputBase-root": { height: 40 },
      }}
    >
      <FormLabel id={labelId}>{label}</FormLabel>
      <Select
        aria-labelledby={labelId}
        id={id}
        value={String(selectedOption ?? "")}
        onChange={handleChange}
      >
        {availableOptions.map((option) => (
          <MenuItem key={String(option)} value={String(option)}>
            {t(String(option))}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
